module.exports = __webpack_public_path__ + "img/location.4ae219a5.svg";